module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("I arrived in Britain in 1967 to join my mother and stepfather at the age of 14. After leaving school at 16, I spent three years in the British Army. After leaving the army, I worked as a truck driver for many years, until 1992 when I returned to academic studies. In 1997 I achieved a 2:1 (Hons.) degree from Luton University, followed by a post-graduate Diploma and a Masters’ degree from De Montfort University in 2004. My first book, "), _c('em', [_vm._v("Stolen Inheritance")]), _vm._v(", was published in 2019, after many years of research. "), _c('em', [_vm._v("Man, God, Religion, and State")]), _vm._v(" is my second publication and I hope readers will find it stimulating and enjoyable.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0